import Tooltip from "@material-ui/core/Tooltip";
import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import ConfirmationModal from "../../../../../components/modules/ConfirmationModal";
import PrimaryButton from "../../../../../components/redesign/elements/Button/PrimaryButton";
import api from "../../../../../api";
import { BrandgenCampaignPool } from "../../../../../types/campaignTypes";
import { successToaster } from "../../../../../helpers/toasters";

const archiveCampagin = async (brandgenCampaignId: string) => {
  try {
    await api.archiveCampaign(brandgenCampaignId, { archived: true });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("archiveCampagin error: ", error);
  }
};

type ArchiveCampaignButtonProps = {
  campaignToArchive: BrandgenCampaignPool;
  fetchAndSetCampaings: () => void;
};

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const ArchiveCampaignButton: FC<ArchiveCampaignButtonProps> = ({ campaignToArchive, fetchAndSetCampaings }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleOpenConfirmModal = () => setIsConfirmModalOpen(true);
  const handleCloseConfirmModal = () => setIsConfirmModalOpen(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await archiveCampagin(campaignToArchive.brandgenCampaignPoolId);
    await fetchAndSetCampaings();
    successToaster(`Campaign "${campaignToArchive.name}" is successfully archived.`, 5000);
    setIsLoading(false);
  };

  const isProcessing = campaignToArchive.status === "processing";

  return (
    <>
      <Tooltip title={isProcessing ? "Campaign is still being created" : ""}>
        <span>
          {useNewDesign ? (
            <PrimaryButton
              onClick={handleOpenConfirmModal}
              disabled={campaignToArchive.active || isLoading || isProcessing}
            >
              Archive Campaign
            </PrimaryButton>
          ) : (
            <Button
              onClick={handleOpenConfirmModal}
              isLoading={isLoading}
              loaderSize={30}
              disabled={campaignToArchive.active || isProcessing}
            >
              Archive Campaign
            </Button>
          )}
        </span>
      </Tooltip>

      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        confirmButtonLabel="Archive"
        confirmQuestion='The archived campaign will be removed from the campaign selector options. But you can still unarchive it later in the campaigns dashboard. To open the campaigns dashboard click the "View All Campaigns" button.'
        handleConfirm={handleConfirm}
        handleClose={handleCloseConfirmModal}
      />
    </>
  );
};

export default ArchiveCampaignButton;
